// 연락처 정보 상수
export const CONTACT_INFO = {
  GITHUB: 'https://github.com/qlsl1198',
  LINKEDIN: 'https://www.linkedin.com/in/%EC%88%98%EB%B9%88-%EA%B9%80-a55a44372/',
  EMAIL: 'qlsl1198@gmail.com',
  PHONE: '+82 10-5554-1198',
  LOCATION: '대구광역시, 대한민국'
} as const; 